/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getGynaecHistories } from 'app/entities/gynaec-history/gynaec-history.reducer';
import { CycleStatus } from 'app/shared/model/enumerations/cycle-status.model';
import { createEntity, getEntity, reset, updateEntity } from './menses-event.reducer';

export const MensesEventUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const gynaecHistories = useAppSelector(state => state.gynaecHistory.entities);
  const mensesEventEntity = useAppSelector(state => state.mensesEvent.entity);
  const loading = useAppSelector(state => state.mensesEvent.loading);
  const updating = useAppSelector(state => state.mensesEvent.updating);
  const updateSuccess = useAppSelector(state => state.mensesEvent.updateSuccess);
  const cycleStatusValues = Object.keys(CycleStatus);

  const handleClose = () => {
    navigate(`/menses-event${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
    dispatch(getGynaecHistories({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.estimatedStartDate !== undefined && typeof values.estimatedStartDate !== 'number') {
      values.estimatedStartDate = Number(values.estimatedStartDate);
    }
    if (values.actualStartDate !== undefined && typeof values.actualStartDate !== 'number') {
      values.actualStartDate = Number(values.actualStartDate);
    }
    if (values.estimatedEndDate !== undefined && typeof values.estimatedEndDate !== 'number') {
      values.estimatedEndDate = Number(values.estimatedEndDate);
    }
    if (values.actualEndDate !== undefined && typeof values.actualEndDate !== 'number') {
      values.actualEndDate = Number(values.actualEndDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...mensesEventEntity,
      ...values,
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      gynaecHistory: gynaecHistories.find(it => it.id.toString() === values.gynaecHistory?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          status: 'ESTIMATED',
          ...mensesEventEntity,
          patient: mensesEventEntity?.patient?.id,
          gynaecHistory: mensesEventEntity?.gynaecHistory?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.mensesEvent.home.createOrEditLabel" data-cy="MensesEventCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.mensesEvent.home.createOrEditLabel">Create or edit a MensesEvent</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="menses-event-id"
                  label={translate('tinyMedicRestApp.mensesEvent.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.mensesEvent.estimatedStartDate')}
                id="menses-event-estimatedStartDate"
                name="estimatedStartDate"
                data-cy="estimatedStartDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mensesEvent.actualStartDate')}
                id="menses-event-actualStartDate"
                name="actualStartDate"
                data-cy="actualStartDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mensesEvent.estimatedEndDate')}
                id="menses-event-estimatedEndDate"
                name="estimatedEndDate"
                data-cy="estimatedEndDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mensesEvent.actualEndDate')}
                id="menses-event-actualEndDate"
                name="actualEndDate"
                data-cy="actualEndDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mensesEvent.status')}
                id="menses-event-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {cycleStatusValues.map(cycleStatus => (
                  <option value={cycleStatus} key={cycleStatus}>
                    {translate(`tinyMedicRestApp.CycleStatus.${cycleStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.mensesEvent.comments')}
                id="menses-event-comments"
                name="comments"
                data-cy="comments"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mensesEvent.active')}
                id="menses-event-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mensesEvent.draft')}
                id="menses-event-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mensesEvent.cursor')}
                id="menses-event-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mensesEvent.lastUpdated')}
                id="menses-event-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mensesEvent.microSec')}
                id="menses-event-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mensesEvent.timestampEntry')}
                id="menses-event-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="menses-event-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.mensesEvent.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="menses-event-gynaecHistory"
                name="gynaecHistory"
                data-cy="gynaecHistory"
                label={translate('tinyMedicRestApp.mensesEvent.gynaecHistory')}
                type="select"
              >
                <option value="" key="0" />
                {gynaecHistories
                  ? gynaecHistories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/menses-event" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MensesEventUpdate;
